import { render, staticRenderFns } from "./integralGrowth.vue?vue&type=template&id=205dcbaa&scoped=true&"
import script from "./integralGrowth.vue?vue&type=script&lang=js&"
export * from "./integralGrowth.vue?vue&type=script&lang=js&"
import style0 from "./integralGrowth.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./integralGrowth.vue?vue&type=style&index=1&id=205dcbaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205dcbaa",
  null
  
)

component.options.__file = "integralGrowth.vue"
export default component.exports